import React from "react";
import { CITIES, SERVICE_AREAS, ALTERNATIVES, SEO_SOLUTIONS } from "../../lib/seoLanding";

const LOCAL_BUSINESS = {
  "@context": "https://schema.org",
  "@type": "LocalBusiness",
  "@id": "https://ojavana.com/#business",
  name: "O'javana",
  url: "https://ojavana.com",
  email: "support@ojavana.com",
  telephone: "+41 32 510 06 20",
  image: "https://ojavana.com/wp-content/uploads/2025/12/ojavana-logo-sky-blue.png",
  logo: "https://ojavana.com/wp-content/uploads/2025/12/ojavana-logo-sky-blue.png",
  priceRange: "CHF 39 – CHF 149 / month",
  description:
    "O'javana — Swiss-made cloud POS, Self-Order Kiosk, Online Shop and Payment Terminals for restaurants and retail. Operated from Boudry, Canton Neuchâtel, Switzerland.",
  address: {
    "@type": "PostalAddress",
    streetAddress: "Rue Louis-Favre 12",
    addressLocality: "Boudry",
    addressRegion: "Canton de Neuchâtel",
    postalCode: "2017",
    addressCountry: "CH",
  },
  geo: {
    "@type": "GeoCoordinates",
    latitude: 46.9489,
    longitude: 6.8336,
  },
  areaServed: [
    { "@type": "Country", name: "Switzerland" },
    { "@type": "Country", name: "Germany" },
    { "@type": "Country", name: "France" },
    { "@type": "Country", name: "Italy" },
    { "@type": "Country", name: "Austria" },
    { "@type": "Country", name: "United Kingdom" },
    { "@type": "Country", name: "United Arab Emirates" },
    { "@type": "Country", name: "Saudi Arabia" },
    { "@type": "Country", name: "United States" },
    { "@type": "Country", name: "Canada" },
  ],
  openingHoursSpecification: [
    {
      "@type": "OpeningHoursSpecification",
      dayOfWeek: ["Monday", "Tuesday", "Wednesday", "Thursday", "Friday"],
      opens: "08:00",
      closes: "19:00",
    },
  ],
  sameAs: ["https://ojavana.com"],
};

const ORGANIZATION = {
  "@context": "https://schema.org",
  "@type": "Organization",
  "@id": "https://ojavana.com/#org",
  name: "O'javana",
  legalName: "Web & Print Media Switzerland Sàrl",
  url: "https://ojavana.com",
  logo: "https://ojavana.com/wp-content/uploads/2025/12/ojavana-logo-sky-blue.png",
  taxID: "CHE-153.649.731",
  contactPoint: {
    "@type": "ContactPoint",
    telephone: "+41 32 510 06 20",
    email: "support@ojavana.com",
    contactType: "customer support",
    areaServed: "CH",
    availableLanguage: ["en", "fr", "de", "it"],
  },
};

const SITEMAP_DATA = (origin = "https://ojavana.com") => ({
  "@context": "https://schema.org",
  "@type": "SiteNavigationElement",
  name: "O'javana sitemap",
  url: `${origin}/sitemap`,
  hasPart: [
    `${origin}/`,
    `${origin}/why`,
    `${origin}/about`,
    `${origin}/solutions`,
    `${origin}/solutions/pos`,
    `${origin}/solutions/kiosk`,
    `${origin}/solutions/waiter-app`,
    `${origin}/solutions/qr-order-pay`,
    `${origin}/solutions/online-shop`,
    `${origin}/solutions/payment-terminals`,
    `${origin}/solutions/gift-cards-loyalty`,
    `${origin}/industries`,
    `${origin}/pricing`,
    `${origin}/configurator`,
    `${origin}/payments`,
    `${origin}/compare/lightspeed`,
    `${origin}/contact`,
    `${origin}/callback`,
    `${origin}/sitemap`,
    `${origin}/legal/imprint`,
    ...CITIES.map((c) => `${origin}/pos/${c.slug}`),
    ...SERVICE_AREAS.map((a) => `${origin}/service-areas/${a.slug}`),
    ...ALTERNATIVES.map((a) => `${origin}/alternatives/${a.slug}`),
    ...SEO_SOLUTIONS.map((s) => `${origin}/${s.slug}`),
  ].map((u) => ({ "@type": "WebPage", url: u })),
});

function JsonLd({ data, id }) {
  return (
    <script
      type="application/ld+json"
      data-testid={`jsonld-${id}`}
      // eslint-disable-next-line react/no-danger
      dangerouslySetInnerHTML={{ __html: JSON.stringify(data) }}
    />
  );
}

export function LocalBusinessJsonLd() {
  return (
    <>
      <JsonLd id="local-business" data={LOCAL_BUSINESS} />
      <JsonLd id="organization" data={ORGANIZATION} />
    </>
  );
}

export function SitemapJsonLd() {
  const origin = typeof window !== "undefined" ? window.location.origin : "https://ojavana.com";
  return <JsonLd id="sitemap" data={SITEMAP_DATA(origin)} />;
}
